module.exports = __webpack_public_path__ + "img/envelope-open-fill.a1493204.svg";